// This can be a nice hook where we can store all the types of Forms right now;
// And what they should include
// So we are passing here name of the form, and getting back list of components that should include

import { GROUPED_INPUTS, INPUT_TYPE } from '../constants';

// in the form. Just array with strings. Then we are passing back to useLeadsBuilder this array
const useListOfForms = (formName: string | null) => {
  const basic = [GROUPED_INPUTS.CONTACT_INFORMATION];

  const basicHandraiser = [GROUPED_INPUTS.BASIC_HANDRAISER];

  const genericForm = [INPUT_TYPE.TOPIC_OF_INTEREST, ...basic];

  const tradeInForm = [GROUPED_INPUTS.TRADE_IN_VEHICLE, GROUPED_INPUTS.MODEL_OF_INTEREST, ...basic];

  const testDriveForm = [
    GROUPED_INPUTS.MODEL_OF_INTEREST,
    ...basic,
    GROUPED_INPUTS.TEST_DRIVE_BOOK,
  ];

  // Checkboxes
  const multipleSelectForm = [...basicHandraiser, INPUT_TYPE.MODEL_LINES_SELECTED];

  // Custom dropdown selector from config file
  const modelSelectForm = [...basicHandraiser, INPUT_TYPE.MODEl_LINE_SELECT_CUSTOM];

  const militaryForm = [GROUPED_INPUTS.MILITARY_INFORMATION];

  // Schedule Service Form
  const schedServiceForm = [GROUPED_INPUTS.SCHEDULE_SERVICE];

  // Generic Event Lead Form
  const genericEventForm = [
    GROUPED_INPUTS.MODEL_OF_INTEREST,
    ...basic,
    INPUT_TYPE.PURCHASE_TIME_FRAME,
    INPUT_TYPE.PREFERRED_DEALER,
  ];

  if (formName === 'contact-dealer' || formName === 'basic') return basic;
  if (formName === 'military') return militaryForm;
  if (formName === 'base') return basicHandraiser;
  if (formName === 'testDrive') return testDriveForm;
  if (formName === 'general') return genericForm;
  if (formName === 'tradeIn') return tradeInForm;
  if (formName === 'modelSelect') return modelSelectForm;
  if (formName === 'multipleSelect') return multipleSelectForm;
  if (formName === 'schedService') return schedServiceForm;
  if (formName === 'eventTOR') return genericEventForm;
  if (formName === 'eventMTL') return genericEventForm;
  if (formName === 'eventVAN') return genericEventForm;
  if (formName === 'eventEDM') return genericEventForm;

  return genericForm;
};

export default useListOfForms;
